/** @format */

import { QUERY_KEYS } from "../../constant/queryKeys.constant";
import { queryKeys } from "../queryKeys";
import createQuery from "src/api/create-query.js";

export const useGetUserMe = createQuery({
  url: "/user/me",
  method: "GET",
});

export const useGetUserByID = createQuery({
  url: (user_id) => `/user/${user_id}`,
  method: "GET",
});

export const useGetUserCertificatesByUserID = createQuery({
  url: (user_id) => `/user/${user_id}/certificates`,
  method: "GET",
});

export const useGetUserEducationsByUserID = createQuery({
  url: (user_id) => `/user/${user_id}/educations`,
  queryKey: (_, { user_id }) =>
    queryKeys[QUERY_KEYS.education].getEducationByUserID(user_id).queryKey,
});

export const useGetUserExperiencesByUserID = createQuery({
  url: (user_id) => `/user/${user_id}/experiences`,
  queryKey: (_, { user_id }) =>
    queryKeys[QUERY_KEYS.experience].getExperienceByUserID(user_id).queryKey,
});

export const useGetUserSkillsByUserID = createQuery({
  url: ({ user_id }) => `/user/${user_id}/skills`,
  queryKey: (_, { user_id }) =>
    queryKeys[QUERY_KEYS.skill].getSkillByUserID(user_id).queryKey,
});

export const useGetUserCertificateByID = createQuery({
  url: (certificate_id) => `/user/certificate/${certificate_id}`,
  method: "GET",
});

export const useGetUserFirstCert = createQuery({
  url: "/user/certificate/firstcert",
  method: "GET",
});

export const useGetUserCertificates = createQuery({
  url: "/user/certificates",
  method: "GET",
});

export const useGetUserEducationByID = createQuery({
  url: (education_id) => `/user/education/${education_id}`,
  method: "GET",
});

export const useGetUserEducations = createQuery({
  url: "/user/educations",
  method: "GET",
});

export const useGetUserExperienceByID = createQuery({
  url: (experience_id) => `/user/experience/${experience_id}`,
  method: "GET",
});

export const useGetUserExperiences = createQuery({
  url: "/user/experiences",
  method: "GET",
});

export const useGetUserPlanByID = createQuery({
  url: (user_plan_id) => `/user/plan/${user_plan_id}`,
  method: "GET",
});

export const useGetUserResumeByID = createQuery({
  url: (resume_id) => `/user/resume/${resume_id}`,
  method: "GET",
});

export const useGetUserResumes = createQuery({
  url: "/user/resumes",
  method: "GET",
});

export const useGetUserSkills = createQuery({
  url: "/user/skills",
  method: "GET",
});

export const useGetUserSubscriptionByID = createQuery({
  url: (subscription_id) => `/user/subscription/${subscription_id}`,
  method: "GET",
});

export const useGetUserSubscriptionMe = createQuery({
  url: "/user/subscription/me",
  method: "GET",
});
